var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-calendar"},[_c('WrapperLink',{staticClass:"event-btn btn btn-primary calendar-link",attrs:{"icon":_vm.svgIcons.arrow,"link":"link"}},[_c('a',{ref:"calendar",staticClass:"wrapper base"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }